import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { DialogService } from './dialog.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonModule } from '../button/button.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    ButtonModule,
    SvgIconModule
  ],
  declarations: [
    DialogComponent,
  ],
  providers: [
    DialogService,
  ],
  entryComponents: [
    DialogComponent,
  ],
})
export class DialogModule {}
